"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiMethod = exports.DydxAsset = exports.DydxMarket = exports.StarkwareOrderSide = exports.StarkwareOrderType = exports.NetworkId = void 0;
var NetworkId;
(function (NetworkId) {
    NetworkId[NetworkId["MAINNET"] = 1] = "MAINNET";
    NetworkId[NetworkId["ROPSTEN"] = 3] = "ROPSTEN";
    NetworkId[NetworkId["GOERLI"] = 5] = "GOERLI";
})(NetworkId = exports.NetworkId || (exports.NetworkId = {}));
var StarkwareOrderType;
(function (StarkwareOrderType) {
    StarkwareOrderType["LIMIT_ORDER_WITH_FEES"] = "LIMIT_ORDER_WITH_FEES";
})(StarkwareOrderType = exports.StarkwareOrderType || (exports.StarkwareOrderType = {}));
var StarkwareOrderSide;
(function (StarkwareOrderSide) {
    StarkwareOrderSide["BUY"] = "BUY";
    StarkwareOrderSide["SELL"] = "SELL";
})(StarkwareOrderSide = exports.StarkwareOrderSide || (exports.StarkwareOrderSide = {}));
// TODO: De-dup with other definitions.
var DydxMarket;
(function (DydxMarket) {
    DydxMarket["BTC_USD"] = "BTC-USD";
    DydxMarket["ETH_USD"] = "ETH-USD";
    DydxMarket["LINK_USD"] = "LINK-USD";
    DydxMarket["AAVE_USD"] = "AAVE-USD";
    DydxMarket["UNI_USD"] = "UNI-USD";
    DydxMarket["SUSHI_USD"] = "SUSHI-USD";
    DydxMarket["SOL_USD"] = "SOL-USD";
    DydxMarket["YFI_USD"] = "YFI-USD";
    DydxMarket["ONEINCH_USD"] = "1INCH-USD";
    DydxMarket["AVAX_USD"] = "AVAX-USD";
    DydxMarket["SNX_USD"] = "SNX-USD";
    DydxMarket["CRV_USD"] = "CRV-USD";
    DydxMarket["UMA_USD"] = "UMA-USD";
    DydxMarket["DOT_USD"] = "DOT-USD";
    DydxMarket["DOGE_USD"] = "DOGE-USD";
    DydxMarket["MATIC_USD"] = "MATIC-USD";
    DydxMarket["MKR_USD"] = "MKR-USD";
    DydxMarket["FIL_USD"] = "FIL-USD";
    DydxMarket["ADA_USD"] = "ADA-USD";
    DydxMarket["ATOM_USD"] = "ATOM-USD";
    DydxMarket["COMP_USD"] = "COMP-USD";
    DydxMarket["BCH_USD"] = "BCH-USD";
    DydxMarket["LTC_USD"] = "LTC-USD";
    DydxMarket["EOS_USD"] = "EOS-USD";
    DydxMarket["ALGO_USD"] = "ALGO-USD";
    DydxMarket["ZRX_USD"] = "ZRX-USD";
    DydxMarket["XMR_USD"] = "XMR-USD";
    DydxMarket["ZEC_USD"] = "ZEC-USD";
    DydxMarket["ENJ_USD"] = "ENJ-USD";
    DydxMarket["ETC_USD"] = "ETC-USD";
    DydxMarket["XLM_USD"] = "XLM-USD";
    DydxMarket["TRX_USD"] = "TRX-USD";
    DydxMarket["XTZ_USD"] = "XTZ-USD";
    DydxMarket["HNT_USD"] = "HNT-USD";
    DydxMarket["ICP_USD"] = "ICP-USD";
    DydxMarket["RUNE_USD"] = "RUNE-USD";
    DydxMarket["LUNA_USD"] = "LUNA-USD";
    DydxMarket["NEAR_USD"] = "NEAR-USD";
    DydxMarket["AR_USD"] = "AR-USD";
    DydxMarket["FLOW_USD"] = "FLOW-USD";
    DydxMarket["PERP_USD"] = "PERP-USD";
    DydxMarket["REN_USD"] = "REN-USD";
    DydxMarket["CELO_USD"] = "CELO-USD";
    DydxMarket["KSM_USD"] = "KSM-USD";
    DydxMarket["BAL_USD"] = "BAL-USD";
    DydxMarket["BNT_USD"] = "BNT-USD";
    DydxMarket["MIR_USD"] = "MIR-USD";
    DydxMarket["SRM_USD"] = "SRM-USD";
    DydxMarket["LON_USD"] = "LON-USD";
    DydxMarket["DODO_USD"] = "DODO-USD";
    DydxMarket["ALPHA_USD"] = "ALPHA-USD";
    DydxMarket["WNXM_USD"] = "WNXM-USD";
    DydxMarket["XCH_USD"] = "XCH-USD";
})(DydxMarket = exports.DydxMarket || (exports.DydxMarket = {}));
var DydxAsset;
(function (DydxAsset) {
    DydxAsset["USDC"] = "USDC";
    DydxAsset["BTC"] = "BTC";
    DydxAsset["ETH"] = "ETH";
    DydxAsset["LINK"] = "LINK";
    DydxAsset["AAVE"] = "AAVE";
    DydxAsset["UNI"] = "UNI";
    DydxAsset["SUSHI"] = "SUSHI";
    DydxAsset["SOL"] = "SOL";
    DydxAsset["YFI"] = "YFI";
    DydxAsset["ONEINCH"] = "1INCH";
    DydxAsset["AVAX"] = "AVAX";
    DydxAsset["SNX"] = "SNX";
    DydxAsset["CRV"] = "CRV";
    DydxAsset["UMA"] = "UMA";
    DydxAsset["DOT"] = "DOT";
    DydxAsset["DOGE"] = "DOGE";
    DydxAsset["MATIC"] = "MATIC";
    DydxAsset["MKR"] = "MKR";
    DydxAsset["FIL"] = "FIL";
    DydxAsset["ADA"] = "ADA";
    DydxAsset["ATOM"] = "ATOM";
    DydxAsset["COMP"] = "COMP";
    DydxAsset["BCH"] = "BCH";
    DydxAsset["LTC"] = "LTC";
    DydxAsset["EOS"] = "EOS";
    DydxAsset["ALGO"] = "ALGO";
    DydxAsset["ZRX"] = "ZRX";
    DydxAsset["XMR"] = "XMR";
    DydxAsset["ZEC"] = "ZEC";
    DydxAsset["ENJ"] = "ENJ";
    DydxAsset["ETC"] = "ETC";
    DydxAsset["XLM"] = "XLM";
    DydxAsset["TRX"] = "TRX";
    DydxAsset["XTZ"] = "XTZ";
    DydxAsset["HNT"] = "HNT";
    DydxAsset["ICP"] = "ICP";
    DydxAsset["RUNE"] = "RUNE";
    DydxAsset["LUNA"] = "LUNA";
    DydxAsset["NEAR"] = "NEAR";
    DydxAsset["AR"] = "AR";
    DydxAsset["FLOW"] = "FLOW";
    DydxAsset["PERP"] = "PERP";
    DydxAsset["REN"] = "REN";
    DydxAsset["CELO"] = "CELO";
    DydxAsset["KSM"] = "KSM";
    DydxAsset["BAL"] = "BAL";
    DydxAsset["BNT"] = "BNT";
    DydxAsset["MIR"] = "MIR";
    DydxAsset["SRM"] = "SRM";
    DydxAsset["LON"] = "LON";
    DydxAsset["DODO"] = "DODO";
    DydxAsset["ALPHA"] = "ALPHA";
    DydxAsset["WNXM"] = "WNXM";
    DydxAsset["XCH"] = "XCH";
})(DydxAsset = exports.DydxAsset || (exports.DydxAsset = {}));
// ============ API Request Parameters ============
var ApiMethod;
(function (ApiMethod) {
    ApiMethod["POST"] = "POST";
    ApiMethod["PUT"] = "PUT";
    ApiMethod["GET"] = "GET";
    ApiMethod["DELETE"] = "DELETE";
})(ApiMethod = exports.ApiMethod || (exports.ApiMethod = {}));
//# sourceMappingURL=data:application/json;base64,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